import React, { useEffect, useState } from "react";

import ResetPasswordValidation from "../../yup/Auth/ResetPasswordValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Button from "../Ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { ResetPasswordAction } from "../../redux/Action/AuthAction";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { VerifyMailType } from "../../constants/Constants";
import { ImageContainer } from "../../constants/ImagesConstants";
import { FormattedMessage, useIntl } from "react-intl";

const { EyeImage, EyeView, Logo } = ImageContainer;

interface FormInputs {
  password: string;
  confirm_password: string;
}

const ResetPasswordModel = ({ resetData }: any) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const intl = useIntl();

  const resetPassword = useSelector((state: any) => state.ResetPasswordState);

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<FormInputs>({
    mode: "onChange",
    resolver: yupResolver(ResetPasswordValidation),
    defaultValues: {
      password: "",
      confirm_password: "",
    },
  });

  /* ***************** Form Handler ***************** */
  const onSubmit = (payload: any) => {
    const data = {
      email: resetData?.email,
      otp: resetData?.otp,
      password: payload?.password,
      verify_type: VerifyMailType?.OtpVerify,
    };
    dispatch(ResetPasswordAction(data));

    $(".btnClose").click(() => {
      reset();
      dispatch(ResetPasswordAction("RESET"));
    });
  };

  useEffect(() => {
    if (resetPassword?.status) {
      $(".btnClose").click();
      navigate("/login");
    }
  }, [resetPassword]);

  useEffect(() => {
    $(".btnClose").click(() => {
      reset();
    });
    $(".modal-backdrop").remove();
    return () => {
      dispatch(ResetPasswordAction("RESET"));
    };
  }, []);

  return (
    <>
      <div
        className="modal modelStyle fade"
        id="ResetPassword"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btnClose"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="icon-close"></span>
              </button>
              <div className="row">
                <div className="col-md-8 mx-auto text-center">
                  <div className="modelLogo">
                    <img src={Logo} alt="logo" />
                  </div>
                  <h2>
                    <FormattedMessage id="reset_password" />
                  </h2>
                  <p>
                    <FormattedMessage id="create_a_new_password_for_login" />
                  </p>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="inputIcon my-4">
                      <label className="form-label">
                        <FormattedMessage id="password" />
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder={intl.formatMessage({
                          id: "enter_password",
                        })}
                        {...register("password")}
                      />
                      <span className="iconLeft icon-lock"></span>
                      <span
                        className="iconRight viewPassword"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <img alt="hide" src={EyeView} />
                        ) : (
                          <img alt="view" src={EyeImage} />
                        )}
                      </span>
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        render={({ message }) => (
                          <p className="text-danger">{message}</p>
                        )}
                      />
                    </div>
                    <div className="inputIcon mb-4">
                      <label className="form-label">
                        <FormattedMessage id="confirm_password" />
                      </label>
                      <input
                        type={showPassword2 ? "text" : "password"}
                        className="form-control"
                        placeholder={intl.formatMessage({
                          id: "enter_confirm_password",
                        })}
                        // placeholder='Enter Confirm Password'
                        {...register("confirm_password")}
                      />

                      <span className="iconLeft icon-lock"></span>
                      <span
                        className="iconRight viewPassword"
                        onClick={() => setShowPassword2(!showPassword2)}
                      >
                        {showPassword2 ? (
                          <img alt="hide" src={EyeView} />
                        ) : (
                          <img alt="view" src={EyeImage} />
                        )}
                      </span>

                      <ErrorMessage
                        errors={errors}
                        name="confirm_password"
                        render={({ message }) => (
                          <p className="text-danger">{message}</p>
                        )}
                      />
                    </div>

                    {/* <button type="submit" className="btn btn-fill mb-4">Submit</button> */}
                    <Button
                      type="submit"
                      className="btn btn-fill mb-4"
                      text={intl.formatMessage({ id: "submit" })}
                      isLoading={resetPassword?.loading}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ResetPasswordModel);
